
(function() {
    'use strict';



    // Helper functions
    const _qs = (s, p = document) => p.querySelector(s);
    const _qsa = (s, p = document) => p.querySelectorAll(s);

    const FacetsHandler = {
        init: function() {
            try {
                this.form = _qs('#FacetFiltersForm');
                if (!this.form) {

                    return;
                }


                this.bindEvents();
                this.initSliders();
            } catch (e) {

            }
        },

        bindEvents: function() {
            // Checkbox changes
            const checkboxes = _qsa('input[type="checkbox"], input[type="radio"]', this.form);


            checkboxes.forEach(input => {
                input.addEventListener('change', (e) => {

                    this.handleFilterChange();
                });
            });

            // Range slider inputs
            const ranges = _qsa('input[type="range"]:not(.double-thumb-min-range):not(.double-thumb-max-range)', this.form);
            ranges.forEach(input => {
                input.addEventListener('change', (e) => {

                     this.handleFilterChange();
                });
            });
        },

        initSliders: function() {
            const sliderGroups = _qsa('.double-thumb-range-slider');


            if (!sliderGroups.length) return;

            sliderGroups.forEach(slider => {
                this.setupDoubleThumbSlider(slider);
            });
        },

        setupDoubleThumbSlider: function(slider) {
             const minInput = slider.querySelector('.double-thumb-min-range');
             const maxInput = slider.querySelector('.double-thumb-max-range');
             const track = slider.querySelector('.double-thumb-slider-track');
             const parent = slider.closest('.facets-sidebar__range-group');
             const minDisplay = parent.querySelector('.double-thumb-min-value');
             const maxDisplay = parent.querySelector('.double-thumb-max-value');

             // Initial values
             const updateTrack = () => {
                 const min = parseInt(minInput.value);
                 const max = parseInt(maxInput.value);
                 const rangeMax = parseInt(minInput.max);

                 // Prevent crossover
                 if (min > max) {
                     const tmp = min;
                     minInput.value = max;
                     maxInput.value = tmp;
                 }

                 const percent1 = ((minInput.value - 1) / (rangeMax - 1)) * 100;
                 const percent2 = ((maxInput.value - 1) / (rangeMax - 1)) * 100;

                 track.style.background = `linear-gradient(to right, #ddd ${percent1}%, #c0272d ${percent1}%, #c0272d ${percent2}%, #ddd ${percent2}%)`;

                 // Update display text (simplified assumption: values map 1:1 to option list indices)
                 // We need to look up the actual label text from the hidden list
                 const optionsList = parent.querySelector('.filter-options');
                 if(optionsList) {
                     const labels = optionsList.querySelectorAll('label span');
                     if(labels[minInput.value - 1]) minDisplay.textContent = labels[minInput.value - 1].textContent;
                     if(labels[maxInput.value - 1]) maxDisplay.textContent = labels[maxInput.value - 1].textContent;
                 }
             };

             minInput.addEventListener('input', updateTrack);
             maxInput.addEventListener('input', updateTrack);

             // Only trigger fetch on 'change' (when user releases mouse)
             minInput.addEventListener('change', (e) => {

                 this.handleSliderChange(e);
             });
             maxInput.addEventListener('change', (e) => {

                 this.handleSliderChange(e);
             });

             updateTrack();
        },

        handleSliderChange: function(e) {
            // Logic to sync hidden checkboxes or URL params based on slider selection
            const group = e.target.closest('.facets-sidebar__range-group');
            const minInput = group.querySelector('.double-thumb-min-range');
            const maxInput = group.querySelector('.double-thumb-max-range');
            const options = group.querySelectorAll('.filter-options input'); // Hidden checkboxes

            const rangeMin = parseInt(minInput.min) || 1;
            const rangeMax = parseInt(minInput.max);
            const currentMin = parseInt(minInput.value);
            const currentMax = parseInt(maxInput.value);

            // If the slider covers the full range (start to end), treat it as "no filter"
            const isFullRange = (currentMin === rangeMin && currentMax === rangeMax);

            const minIndex = currentMin - 1;
            const maxIndex = currentMax - 1;

            options.forEach((opt, index) => {
                if (isFullRange) {
                     // Uncheck all to disable filter (allows untagged items to show)
                     opt.checked = false;
                } else {
                    // Check options within selected range
                    if (index >= minIndex && index <= maxIndex) {
                        opt.checked = true;
                    } else {
                        opt.checked = false;
                    }
                }
            });

            this.handleFilterChange();
        },

        handleFilterChange: function() {
            try {
                const currentUrl = new URL(window.location.href);

                // Clean path: /collections/handle/tag -> /collections/handle
                const pathParts = currentUrl.pathname.split('/');
                const collectionIndex = pathParts.indexOf('collections');
                if (collectionIndex !== -1 && pathParts[collectionIndex + 1]) {
                     // Reset path to just the collection handle
                     currentUrl.pathname = `/collections/${pathParts[collectionIndex + 1]}`;
                }

                // Logic to collect values
                const filters = {};

                const inputs = _qsa('input:checked', this.form);

                inputs.forEach(input => {
                    let name = input.name;
                    // Clean name
                    if (name.startsWith('filter_tag_')) {
                        name = name.replace('filter_tag_', '');
                        name = name.toLowerCase().replace(/-/g, '_');
                    }

                    let value = input.value;
                    if (value.includes(':')) {
                         // Extract value after colon if present (e.g. Length:10mm -> 10mm)
                        value = value.split(':').slice(1).join(':').trim();
                    }

                    if (!filters[name]) filters[name] = [];
                    // Avoid duplicates
                    if (!filters[name].includes(value)) filters[name].push(value);
                });

                // Clear legacy params
                const keysToRemove = [];
                currentUrl.searchParams.forEach((v, k) => {
                    if(k.startsWith('filter[')) keysToRemove.push(k);
                });
                keysToRemove.forEach(k => currentUrl.searchParams.delete(k));

                currentUrl.searchParams.delete('constraint');
                currentUrl.searchParams.delete('page');

                // Construct new params
                Object.keys(filters).forEach(key => {
                    // Join with comma e.g. M2,M3
                    currentUrl.searchParams.set(`filter[${key}]`, filters[key].join(','));
                });



                // Update History
                window.history.pushState({}, '', currentUrl.toString());

                // Trigger Grid Reload
                if (window.Collection && window.Collection.reset && window.Collection.load) {
                     window.Collection.reset();
                     window.Collection.load();
                }
            } catch(e) {

            }
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            FacetsHandler.init();
        });
    } else {
        FacetsHandler.init();
    }

})();
